import ISiteDiaryStaffOnSite from "interfaces/SiteDiary/StaffOnSite/ISiteDiaryStaffOnSite";
import { Badge } from "react-bootstrap";
import { InfoCircleFill } from "react-bootstrap-icons";

const DetailsTemplate = (props: ISiteDiaryStaffOnSite): any => {
  const { cotcQualified, id, notes } = props;

  return (
    <>
      {cotcQualified && <Badge data-testid={`${id}-cotc-badge`} bg="success">COTC</Badge>}
      {" "}
      {notes && notes !== "" && <InfoCircleFill data-testid={`${id}-info`} />}
    </>
  );
};
export default DetailsTemplate;
